import { render, staticRenderFns } from "./configuracion.vue?vue&type=template&id=1bca116f"
import script from "./configuracion.vue?vue&type=script&lang=js"
export * from "./configuracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports